// <s-share-button> opens the device's share sheet where supported, otherwise copies the
// page link to the clipboard and announces "Link copied" in its status region.

class SShareButton extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.querySelector('button')?.addEventListener('click', () => this.#share(), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  async #share() {
    const url = this.dataset.url || window.location.href;
    const title = this.dataset.title || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch {
        // The buyer closed the share sheet; nothing to do.
      }
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
      const status = this.querySelector('[data-share-status]');
      if (status) {
        status.textContent = this.dataset.copiedMessage || '';
        setTimeout(() => { status.textContent = ''; }, 3000);
      }
    } catch {
      window.prompt(this.dataset.title || '', url);
    }
  }
}

if (!customElements.get('s-share-button')) customElements.define('s-share-button', SShareButton);
